<!-- Base Category Search Component -->
<!-- Description: Creating a search component for the dashboard -->
<template>
    <!-- Create a wrapping element -->
    <div>
        <!-- Creating an input field -->
        <label class="search" for="inpt_search">
            <input id="inpt_search" type="text" v-model="search" placeholder="Aladin Foods">
        </label>
        <!-- Implementing a group list (tag from Bootstrap for Vue) -->
        <b-list-group v-if="results.length > 0" class="group-list">
            <!-- Implementing a group list item (tag from Bootstrap for Vue) -->
            <b-list-group-item v-for="(result, index) in results" :key="index" class="d-flex justify-content-between align-items-center">
                <!-- Creating a town category title -->
                <div class="category">
                    <p style="margin-bottom: 0">
                        <span v-if="results[index - 1] === undefined">{{ result.town }}</span>
                        <span v-else-if="results[index - 1].town !== result.town">{{ result.town }}</span>
                        <span>&nbsp;</span>
                    </p>
                </div>
                <!-- Creating the right part for the restaurant name and tags -->
                <div @click="$router.push({ path: '/restaurants/search?restaurant=' + result.id })" class="item">
                    <p class="warp-fix" style="margin-bottom: 0">
                        <b>{{ result.name }}</b>
                        <br>
                        {{ result.tags.join(', ') }}
                    </p>
                </div>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
                <div style="height: 49px; width: 100%; cursor: pointer;" @click="$router.push({ name: 'restaurants-search', params: { ekatte: ekatte } })">
                    <p style="text-align: center; margin-top: 13px;"><b>Разширено търсене</b></p>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<!-- TypeScript code -->
<script>
    // Importing functions
    import {APILookUp} from '../ts/other/additional';

    export default {
        name: 'BaseCategorySearch',
        components: {
        },
        props: {
            ekatte: String,
        },
        data() {
            return {
                search: '',
                results: [],
                focused: false,
            };
        },
        watch: {
            // look up in the API
            search(value) {
                if (value.length > 2) {
                    APILookUp(value).then((response) => {
                        this.results = response.data.data;
                    });
                }
                if (value.length === 0) {
                    this.results = [];
                }
            },
        },
        methods: {},
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    $icn-color: #b4b4b4;
    .list-group-item {
        padding: 0;
        border: 0.5px solid #edeeef;
    }
    .group-list {
        position: absolute;
        width: 29%;
        margin-top: 10px;
        margin-left: 3px;
    }
    .category {
        background: #edeeef;
        width: 40%;
        padding: 15px;
        font-size: 12px;
    }
    .item {
        width: 60%;
        cursor: pointer;
        padding: 5px;
        font-size: 12px;
    }
    .warp-fix {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>